import { render, staticRenderFns } from "./ItemForm.vue?vue&type=template&id=9f125dc4"
import script from "./ItemForm.vue?vue&type=script&lang=js"
export * from "./ItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports